import { Button } from "@mui/material"
import { SingleServiceCenterDto } from "api"
import { trackServiceCenterPhoneClick } from "common/analytics"
import NextLink from "common/bit/NextLink"
import { Mobile } from "common/MediaQueries"
import CardRowText from "components/mapPages/CardRowText"
import styled from "styled-components"
import { StyledRow } from "theme/shared"

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
`

type PopUpHeaderUiProps = {
  centerData: SingleServiceCenterDto
  type?: string
}

const PopUpHeaderUi = ({ centerData, type }: PopUpHeaderUiProps) => {
  const trackPhoneClick = () => {
    trackServiceCenterPhoneClick(
      type ?? "",
      centerData.name,
      "phone_number_popup_clicks"
    )
  }
  function formatPhoneNumber(phone: string): string {
    const cleaned = ("" + phone).replace(/\D/g, "")

    // For mobile numbers (10 digits): 052-447-7428
    if (cleaned.length === 10) {
      const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
      if (match) {
        return `${match[1]}-${match[2]}${match[3]}`
      }
    }

    // For landline numbers (9 digits): 08-926-2099
    if (cleaned.length === 9) {
      const match = cleaned.match(/^(\d{2})(\d{3})(\d{4})$/)
      if (match) {
        return `${match[1]}-${match[2]}${match[3]}`
      }
    }

    return phone
  }
  return (
    <StyledWrapper>
      <StyledRow $gap="30px">
        <CardRowText
          data={formatPhoneNumber(centerData.phone)}
          link={`tel:${centerData.phone}`}
          iconName="phoneCall"
          imageAlt="טלפון"
          trackEvent={trackPhoneClick}
        />

        <CardRowText
          data={formatPhoneNumber(centerData.fax)}
          iconName="fax"
          imageAlt="פקס"
        />
      </StyledRow>
      <StyledRow>
        <CardRowText data={centerData.address} />
      </StyledRow>
      <Mobile>
        <NextLink href={centerData.wazeLink}>
          <Button variant="outlined">ניווט ב-Waze</Button>
        </NextLink>
      </Mobile>
    </StyledWrapper>
  )
}

export default PopUpHeaderUi
